/* eslint-disable import/default */

require('./favicon.ico');

// Main app styles - Webpack will run the associated loader and plug this into the page.
import './styles/main.scss';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

// Root and Main Store
import Root from './components/Root';
import initialState from './reducers/initialState';
import configureStore from './store/configureStore';
import StaticMarkup from './containers/pptx/StaticMarkup';

configureStore(initialState, store => {
  // Create an enhanced history that syncs navigation events with the store
  const history = syncHistoryWithStore(browserHistory, store);

  StaticMarkup.init(store);
  // Reactotron ?
  //import Reactotron from 'reactotron-react-js';
  //Reactotron.configure().connect();

  render(
    <AppContainer>
      <Root store={store} history={history} />
    </AppContainer>,
    document.getElementById('app')
  );

  if (module.hot) {
    module.hot.accept('./components/Root', () => {
      const NewRoot = require('./components/Root').default;
      render(
        <AppContainer>
          <NewRoot store={store} history={history} />
        </AppContainer>,
        document.getElementById('app')
      );
    });
  }
});



// WEBPACK FOOTER //
// ./src/index.js